import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { calculateTotalRow, checkForTotalColumn, qtySizeSplitColumns } from "./data";
import { datatypes, deleteTableColumn } from "data/globalData";
import { Button, Typography } from "@mui/material";
import { AddRounded, EditRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { roundDecimalValueUptoTwoDigit } from "utils/RoundDecimalValue";
import { WhiteBgBox, TotalBox } from "../../CostingDetails/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

const QtySizeWiseSplitTable = ({
	rows,
	setRows,
	totalRow,
	setTotalRow,
	mode = "" || "create" || "edit",
	editMode = false,
	setEditMode = () => {},
	handleSave = () => [],
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...qtySizeSplitColumns.size,
			...colStyle,
			minWidth: 120,
			headerName: qtySizeSplitColumns.size.name,
			field: qtySizeSplitColumns.size.key,
			editable: true,
			colSpan: (value, row) => {
				if (checkForTotalColumn(row)) {
					return 1;
				}
				return undefined;
			},
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...qtySizeSplitColumns.order_qty,
			editable: true,
			...colStyle,
			headerName: qtySizeSplitColumns.order_qty.name,
			field: qtySizeSplitColumns.order_qty.key,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...qtySizeSplitColumns.recieved_qty,
			field: qtySizeSplitColumns.recieved_qty.key,
			headerName: qtySizeSplitColumns.recieved_qty.name,
			editable: true,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...qtySizeSplitColumns.difference_qty,
			field: qtySizeSplitColumns.difference_qty.key,
			headerName: qtySizeSplitColumns.difference_qty.name,
			editable: false,
			...colStyle,
			renderCell: ({ field, row }) => {
				if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
	];

	const [tableColumnsState, setTableColumnsState] = useState([]);
	const [rowsCopy, setRowsCopy] = useState(rows ? [...rows] : []);
	const [deletedRowIds, setDeletedRowIds] = useState([]);

	const defaultRow = tableColumnsState?.reduce((acc, row) => {
		acc[row.key] = getColDefaultValue(row);
		return acc;
	}, {});

	useEffect(() => {
		setTableColumnsState([...defTableColumns]);
		setTotalRow(calculateTotalRow(rows));
	}, []);

	const handleAddRowClick = () => {
		let newRow = { ...defaultRow };
		newRow["id"] = new Date().valueOf();
		newRow["is_new"] = true;
		newRow["created_by"] = user.email;
		setRows((prev) => [...prev, newRow]);
	};
	function handleDeleteRowClick(rowToDelete) {
		setRows((prev) => {
			const newRows = prev.filter((row) => row.id !== rowToDelete.id);
			setDeletedRowIds((prev) => [...prev, rowToDelete.id]);
			setTotalRow(calculateTotalRow(newRows));
			return newRows;
		});
	}
	const processRowUpdate = (newRow, OldRow) => {
		let correct = true;
		tableColumnsState?.forEach((col) => {
			if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
				if (isNaN(newRow[col.key])) correct = false;
		});
		console.log(correct, "sdmnfbnsdfmsd");

		if (correct) {
			const value = roundDecimalValueUptoTwoDigit(
				newRow[qtySizeSplitColumns.recieved_qty.key] - newRow[qtySizeSplitColumns.order_qty.key]
			);
			let updatedNewRow = {
				...newRow,
				[qtySizeSplitColumns.difference_qty.key]: value,
				is_updated: true,
				last_updated_by: user.email,
			};
			setRows((prev) => {
				let newRows = prev.map((row) => {
					if (row.id === updatedNewRow.id) return updatedNewRow;
					else return row;
				});
				setTotalRow(calculateTotalRow(newRows));
				return newRows;
			});
			return updatedNewRow;
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleCancelEditClick = () => {
		setRows(rowsCopy);
		setDeletedRowIds([]);
		setEditMode(false);
	};
	const handleEditClick = () => {
		setEditMode(true);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const result = await handleSave(rows, deletedRowIds);
			if (result) {
				setRows(result);
				setRowsCopy(result);
				setDeletedRowIds([]);
				setEditMode(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Box>
			<Box display="flex" justifyContent="space-between" pt={1} pb={1}>
				<Typography variant="h6"> Qty Size Split </Typography>
				<Box display="flex" columnGap="5px">
					{mode === "create" ? (
						<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
							Add Row
						</Button>
					) : mode === "edit" ? (
						<>
							{editMode ? (
								<>
									<Button variant="contained" size="small" onClick={handleAddRowClick} startIcon={<AddRounded />}>
										Add Row
									</Button>
									<Button variant="outlined" size="small" onClick={handleCancelEditClick}>
										Cancel Edit
									</Button>
									<Button variant="contained" size="small" onClick={handleSaveClick}>
										Save
									</Button>
								</>
							) : (
								<Button variant="contained" size="small" onClick={handleEditClick} startIcon={<EditRounded />}>
									Edit
								</Button>
							)}
						</>
					) : (
						<></>
					)}
				</Box>
			</Box>
			<DataGrid
				rows={rows ? [...rows, totalRow] : []}
				getRowId={(row) => row.id}
				columns={[
					...tableColumnsState,
					deleteTableColumn(handleDeleteRowClick, (row) => (mode !== "create" && !editMode) || checkForTotalColumn(row)),
				]}
				sx={{
					width: "100%",
					// maxHeight: 250,
					"& .MuiDataGrid-row": {
						cursor: "pointer",
					},
					"& .MuiDataGrid-row:hover": {
						backgroundColor: "transparent",
					},
					"& .MuiDataGrid-columnHeader": {
						cursor: "pointer",
						background: grey[400],
						textTransform: "uppercase",
					},
					"& .MuiDataGrid-cell": {
						padding: 0,
					},
				}}
				density="compact"
				disableRowSelectionOnClick
				pagination={false} // Remove footer
				hideFooter={true}
				showCellVerticalBorder
				showColumnVerticalBorder
				isCellEditable={({ row }) => (mode === "create" || editMode) && !checkForTotalColumn(row)}
				processRowUpdate={processRowUpdate}
				autoHeight
			/>
		</Box>
	);
};

export default QtySizeWiseSplitTable;
